import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { StringUtils } from '../../utils/string.utils';
import { LocalAppService } from '../app/local-app.service';
import { firstValueFrom } from 'rxjs';
import { AlertifyService } from './alertify.service';
import { SessionStorageService } from '../session-storage.service';
import { DeviceLocalStorageData } from '../../models/rest/user/device-local-storage-data.model';
import { ExecuteAppResponse } from '../../models/rest/app/execute-app-response';


@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor(
    public authService: AuthService,
    private localAppService: LocalAppService,
    private alertifyService: AlertifyService,
    private sessionStorageService: SessionStorageService
  ) {


  }


  getPhoneNumberWithCountryCode(phone: string | null) {
    if (StringUtils.isEmpty(phone)) return null;

    if (phone!.startsWith("+") && phone!.length > 11) return phone;

    let countryPhoneCode = this.authService.getCountryPhoneCode();
    let returnValue = phone;

    if (!StringUtils.isEmpty(countryPhoneCode)) {
      if (countryPhoneCode == "994" && phone!.length >= 10) {
        returnValue = "${countryPhoneCode!}0${phone.substring(phone.length - 9)}";
      } else {
        returnValue = countryPhoneCode! + phone;
      }
    }

    return returnValue;
  }

  async openWhatsApp(phoneNumber: string | null, message: string, addCountryCode: boolean = true) {
    let deviceLocalStorageData: DeviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();

    let sendWhatsappMessageWithApp = deviceLocalStorageData.sendWhatsappMessageWithApp;

    if (addCountryCode)
      phoneNumber = this.getPhoneNumberWithCountryCode(phoneNumber);

    if (sendWhatsappMessageWithApp) {
      await this.openWhatsAppDesktop(phoneNumber!, message);
    } else {
      this.openWhatsAppWeb(phoneNumber!, message);
    }

  }

  async openWhatsAppDesktop(phoneNumber: string, message: string) {
    try {
      const isAlive = await firstValueFrom(this.localAppService.getLocalAppIsAlive());
      if (!isAlive) {
        this.alertifyService.error('Lokal uygulama servislerine erişim yok');
        return false;
      }
      const response: ExecuteAppResponse = await firstValueFrom(this.localAppService.openWhatsAppDesktop(phoneNumber!, message));
      if (response.isSuccess) {
        this.alertifyService.success('Whatsapp açıldı');
        return true;
      } else {
        this.alertifyService.error(response.message!);
        return false;
      }
    } catch (error) {
      this.alertifyService.error('Lokal Servis Hatası. ' + error);
      return false;
    }
  }
  openWhatsAppWeb(phoneNumber: string, message: string) {

    // Mesajı URL uyumlu hale getir
    const encodedMessage = encodeURIComponent(message);
    // WhatsApp URL şablonu, mesaj ile birlikte
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(url, '_blank');
  }

}
